<template>
  <div v-if="open">
    <div class="modal-backdrop fade show"></div>
    <div
      v-if="open"
      class="modal fade show"
      id="modal-device"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-device-label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modal-device-label">
              {{ modalName }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="closeModal()"
            ></button>
          </div>
          <div class="modal-body">
            <DeviceInfo
              v-if="!isNew && !isEdit && device"
              :time="time"
              :device="device"
              :show-title="false"
              @refresh="refresh"
            />
            <DeviceEdit
              v-if="isNew || isEdit"
              :time="time"
              :selected="selected"
              :is-new="isNew"
              @refresh="refresh"
            />
          </div>
          <div class="modal-footer">
            <!-- Commands -->
            <div class="me-auto"></div>
            <button
              class="btn btn-outline-secondary"
              data-dismiss="modal"
              @click="closeModal()"
            >
              <font-awesome-icon :icon="['fas', 'times']" aria-label="Chiudi" />
              Chiudi
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Components */
import DeviceInfo from '@/components/devices/DeviceInfo.vue'
import DeviceEdit from '@/components/devices/DeviceEdit.vue'

export default {
  name: 'DeviceModal',
  components: {
    DeviceInfo,
    DeviceEdit
  },
  data() {
    return {
      open: false
    }
  },
  props: {
    time: Date,
    device: Object,
    selected: Number,
    isNew: Boolean,
    isEdit: Boolean
  },
  watch: {
    time: function() {
      this.openModal()
    }
  },
  created() {
    this.openModal()
  },
  computed: {
    modalName: function() {
      return this.isNew
        ? 'Nuovo dispositivo'
        : this.isEdit
        ? 'Modifica dispositivo'
        : this.device.name
    }
  },
  methods: {
    openModal() {
      if (this.time) {
        this.open = true
      }
    },
    closeModal() {
      this.open = false
    },
    refresh(alert) {
      this.closeModal()
      this.$emit('refresh', alert)
    }
  }
}
</script>

<style>
.modal {
  z-index: 1070;
}
.modal-body {
  max-height: 100%;
  overflow: scroll;
}
.show {
  display: block;
}
</style>
